module.exports = __webpack_public_path__ + "static/media/container8.e83ca22a.jpg";